import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Link,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Box sx={{ backgroundColor: '#EFDDD0', minHeight: '100vh' }}>
  <Container maxWidth="md" sx={{ py: 4, backgroundColor: "#EFDDD0" }}>
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center" color='#EF7F95'>
        {/* 隐私政策 / Privacy Policy */}
        Privacy Policy
      </Typography>

      <Typography variant="subtitle1" color="text.secondary" align="center" paragraph>
        {/* 最近更新 / Last Updated: {new Date().toLocaleDateString()} */}
        Last Updated: {new Date().toLocaleDateString()}
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* 1. 信息收集 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 1. 收集的信息 / Information We Collect */}
          Information We Collect
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
            //   primary="注册数据：姓名、邮箱、PayPal交易ID（不存储信用卡信息）。"
              secondary="Registration Data: Name, email, and PayPal transaction ID (credit card details are not stored)."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="使用数据：课程进度、AI工具使用日志、IP地址、设备信息。"
              secondary="Usage Data: Course progress, AI tool logs, IP address, device info."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="Cookies：用于登录会话和数据分析（如Google Analytics）。"
              secondary="Cookies: For login sessions and analytics (e.g., Google Analytics)."
            />
          </ListItem>
        </List>
      </Box>

      {/* 2. 数据用途 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 2. 数据用途 / How We Use Your Data */}
          How We Use Your Data
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
            //   primary="提供服务：发送课程链接、处理订阅。"
              secondary="To provide services such as sending course links and handling subscriptions."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="改进产品：分析行为优化课程内容。"
              secondary="To improve our services by analyzing user behavior and optimizing course content."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="营销：经用户同意后发送促销邮件，含退订链接。"
              secondary="For marketing (only if user consents); emails include an unsubscribe link."
            />
          </ListItem>
        </List>
      </Box>

      {/* 3. 数据共享 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 3. 数据共享 / Data Sharing */}
          Data Sharing
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
            //   primary="PayPal：用于处理支付，受其隐私政策约束。"
              secondary="PayPal: For payment processing, subject to PayPal's own privacy policy."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="邮件服务商（如Mailchimp）：用于发送课程链接。"
              secondary="Email services (e.g., Mailchimp): For sending course links."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="法律要求：如配合监管部门调查时可能披露数据。"
              secondary="Legal requirements: Data may be disclosed when legally required."
            />
          </ListItem>
        </List>
      </Box>

      {/* 4. 用户权利 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 4. 用户权利 / User Rights */}
          User Rights 
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText
            //   primary="访问、更正或删除个人数据，请通过邮箱联系客服。"
              secondary="Access, correct, or delete your personal data by contacting our support email."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="拒绝营销邮件（邮件中提供退订链接）。"
              secondary="Opt-out of marketing emails via unsubscribe link included in each email."
            />
          </ListItem>
          <ListItem>
            <ListItemText
            //   primary="GDPR/CCPA适用地区的用户可请求数据可携带或限制处理。"
              secondary="Users under GDPR/CCPA can request data portability or restriction of processing."
            />
          </ListItem>
        </List>
      </Box>

      {/* 5. 数据安全 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 5. 数据安全 / Data Security */}
          Data Security
        </Typography>
        <Typography paragraph>
          {/* 我们采用 HTTPS 加密传输，并进行定期安全审计。所有支付由 PayPal 处理，COCO Excel 不存储任何信用卡信息。 */}
          {/* <br /> */}
          We use HTTPS encryption and conduct regular security audits. Payments are handled by PayPal; COCO Excel does not store credit card details.
        </Typography>
      </Box>

      {/* 6. 数据保留 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 6. 数据保留 / Data Retention */}
          Data Retention
        </Typography>
        <Typography paragraph>
          {/* 用户账户数据将在账户注销后保留最多 6 个月。匿名化分析数据可能长期保留。 */}
          {/* <br /> */}
          Account data is retained up to 6 months after account deletion. Anonymized analytics may be retained indefinitely.
        </Typography>
      </Box>

      {/* 7. 儿童隐私 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 7. 儿童隐私 / Children’s Privacy */}
          Children’s Privacy
        </Typography>
        <Typography paragraph>
          {/* 本服务不面向 18 岁以下用户。 */}
          {/* <br /> */}
          Our services are not intended for users under 18 years old.
        </Typography>
      </Box>

      {/* 8. 政策更新 */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          {/* 8. 政策更新 / Policy Updates */}
          Policy Updates
        </Typography>
        <Typography paragraph>
          {/* 我们会通过邮件或在网站上公告通知隐私政策的变更。 */}
          {/* <br /> */}
          We will notify users of changes to this policy via email or website announcements.
        </Typography>
      </Box>

      {/* 9. 联系方式 */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" gutterBottom>
          {/* 9. 联系方式 / Contact Information */}
          Contact Information
        </Typography>
        <Typography paragraph>
          {/* 如有任何隐私相关问题，请联系： */}
          {/* <br /> */}
          For any privacy-related questions, contact:
        </Typography>
        <Link href="mailto:helper@mindlink.work" color="primary">
          helper@mindlink.work
        </Link>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* <Typography variant="body2" color="text.secondary" align="center">
        © {new Date().getFullYear()} COCO Excel 版权所有 / All Rights Reserved.
      </Typography> */}
    </Paper>
  </Container>
</Box>

  );
};

export default PrivacyPolicy;